module.exports = __webpack_public_path__ + "img/tarj1-4.0b819ddb.svg";